/** "Captado por": campo com regra de alteração (motivo) e histórico. */
import { fmtDateTime } from "@/lib/format";
import { useLookups } from "@/lib/catalog";
import { Field, UserSelect } from "./kit";

export interface OriginChangeRow { id: string; fromUserId: string | null; toUserId: string | null; reason: string | null; batch: boolean; changedBy: string; changedAt: string }

/** Precisa de motivo? (havia valor salvo e mudou) */
export const originNeedsReason = (original: string | null | undefined, value: string | null | undefined) => !!original && (original ?? null) !== (value ?? null);

export function OriginOwnerField({ value, original, canChange, onChange, reason, onReason, required, span = 1, hint }: {
  value: string | null; original?: string | null; canChange?: boolean; onChange: (v: string | null) => void;
  reason: string; onReason: (v: string) => void; required?: boolean; span?: 1 | 2 | 3; hint?: string;
}): JSX.Element {
  const locked = !!original && !canChange;
  return (
    <>
      <Field label="Captado por (equipe)" required={required} span={span}
        hint={locked ? "Já definido. Só o administrador ou o gerente financeiro altera." : hint ?? "Quem do escritório trouxe este cliente/caso. Base do indicador de captação."}>
        {locked ? <input className="input" disabled value={useLookups().userName(original)} /> : <UserSelect value={value} onChange={onChange} emptyLabel="—" />}
      </Field>
      {originNeedsReason(original, value) && (
        <Field label="Motivo da alteração do captador" required span={span === 1 ? 2 : span}>
          <input className="input" value={reason} onChange={(e) => onReason(e.target.value)} placeholder="Ex.: cadastro feito errado; cliente veio pelo Dr. X" />
        </Field>
      )}
    </>
  );
}

export function OriginHistory({ rows }: { rows: OriginChangeRow[] }): JSX.Element | null {
  const { userName } = useLookups();
  if (!rows.length) return null;
  return (
    <details className="small" style={{ marginTop: 6 }}>
      <summary className="muted" style={{ cursor: "pointer" }}>Histórico do "Captado por" ({rows.length})</summary>
      <ul style={{ margin: "6px 0 0", paddingLeft: 18 }}>
        {rows.map((r) => (
          <li key={r.id}>
            {fmtDateTime(r.changedAt)} — {r.fromUserId ? userName(r.fromUserId) : "vazio"} → <b>{r.toUserId ? userName(r.toUserId) : "vazio"}</b>
            {" "}<span className="muted">por {userName(r.changedBy)}{r.batch ? " (lote)" : ""}{r.reason ? ` · ${r.reason}` : ""}</span>
          </li>
        ))}
      </ul>
    </details>
  );
}
